<template>
  <div class="teacher_praise">
    <template v-if="layerpageinfo.total > 0">
      <div class="pro_box">
        <pro_list :list="list"/>
      </div>
      <div class="page_box">
        <myPage :layerpageinfo="layerpageinfo" @pageChange="changePage"></myPage>
      </div>
    </template>
    <!-- 为空 -->
    <div class="no_list" v-else></div>
  </div>
</template>

<script>
  import pro_list from "@/components/list_item/pro_list/pro_list.vue";
  import myPage from "@/components/myPage/myPage";
  export default {
    components:{
      pro_list,
      myPage
    },
    data(){
      return{
        list: [],
        layerpageinfo: {
          pageSize: 8,
          pageNo: 0,
          total: 0
        },
      }
    },
    created() {
      this.getList();
    },
    methods:{
      changePage(val){
        this.layerpageinfo.pageNo = val;
        this.getList();
      },
      //查询该教师的点赞作品
      getList(){
        let params = {
          type: "CollectionTypeLike",
          user_id: this.$route.query.user,
          entity_type: "EntityTypeOpus",
          ...this.layerpageinfo
        }
        this.api.getCollections(params).then(res=>{
          if(res.error['err_code'] !== 0) return;
          this.layerpageinfo.total = res.obj.totalSize;
          let list = res.obj.list;
          let codes = [];
          list.forEach(item =>{
            if(item.code){
              codes.push(item.code)
            }
          })
          if(codes.length > 0){
            this.getOpus(codes);
          }
        })
      },
      //通过code数组查询作品
      getOpus(codes){
        let params = {
          codes: codes.join(',')
        }
        this.api.getOpuses(params).then(res=>{
          if(res.error['err_code'] !== 0) return;
          this.list = res.obj.list;
        })
      }
    }
  }
</script>

<style lang="scss">
  .teacher_praise{
    .pro_box{
      padding: 20px 0;
    }
    .page_box{
      margin-bottom: 50px;
    }
  }
</style>
